export const atomKeys = {
  code_snippets: "code_snippets",
  preferred_language: "preferred_language",
  docsNavigation: "docsNavigation",
  mm2Settings: "mm2Settings",
};
